import BREATH_LOW from './assets/images/breath_low.png';
import AUTHORITY_MGMT_ICON from './assets/images/card_scientech/authority_mgmt_icon.png';
import BODY_TEMP_ICON from './assets/images/card_scientech/body_temp_icon.png';
import BREATH_ICON from './assets/images/card_scientech/breath_icon.png';
import WEIGHT_SCALE from './assets/images/basic/wightScale.png';
import DOOR_CLOSE from './assets/images/card_scientech/door_close.png';
import DOOR_OPEN from './assets/images/card_scientech/door_open.png';
import GLUCOSEMETER_ICON from './assets/images/card_scientech/glucosemeter_icon.png';
import HISTORY_ACTIVITY_ICON from './assets/images/card_scientech/history_activity_icon.png';
import HISTORY_SLEEP_ICON from './assets/images/card_scientech/history_sleep_icon.png';
import HUMID_ICON from './assets/images/card_scientech/humid_icon.png';
import OXIMETER_ICON from './assets/images/card_scientech/oximeter_icon.png';
import PERSONAL_SETTINGS_ICON from './assets/images/card_scientech/personal_settings_icon.png';
import SETTING_RESPO_GROUP_ICON from './assets/images/card_scientech/setting_respo_group_icon.png';
import SLEEP_EFFICIENCY_ICON from './assets/images/card_scientech/sleep_efficiency_icon.png';
import SPHYGMOMANOMETER_ICON from './assets/images/card_scientech/sphygmomanometer_icon.png';
import TEMP_ICON from './assets/images/card_scientech/temp_icon.png';
import TEMP_ICON_1 from './assets/images/card_scientech/temp_icon_1.png';
import TOILET_CLOSE_ICON from './assets/images/card_scientech/toilet_close_icon.png';
import TOILET_OPEN_ICONA from './assets/images/card_scientech/toilet_open_iconA.png';
import TOILET_OPEN_ICONB from './assets/images/card_scientech/toilet_open_iconB.png';
import TRANSCEIVER_INFO_ICON from './assets/images/card_scientech/transceiver_info_icon.png';
import WEIGHT_ICON from './assets/images/card_scientech/weight_icon.png';
import VIBRATION_ICON from './assets/images/card_scientech/vibration_icon.png';

import HEARTBEAT from './assets/images/basic/heartbeat.png';
import HEARTBEAT_SVG from './assets/images/basic/heartbeat.svg';
import HEARTBEAT_1 from './assets/images/basic/heartbeat-1.png';
import HEARTBEAT_2 from './assets/images/basic/heartbeat-2.png';
import HEARTBEAT_3 from './assets/images/basic/heartbeat-3.png';
import BREATH_TIMES_1 from './assets/images/basic/breath-times_1.png';
import BREATH_TIMES_SVG from './assets/images/basic/breath-times.svg';
import ICONA_1 from './assets/images/basic/icona-1.png';
import ICONA_2 from './assets/images/basic/icona-2.png';
import ICONA_3 from './assets/images/basic/MWG_icon_20200624.png';
import ICONB_1 from './assets/images/basic/iconb-1.png';
import ICONB_2 from './assets/images/basic/iconb-2.png';
import ICONC_1 from './assets/images/basic/iconc-1.png';
import ICONC_2 from './assets/images/basic/iconc-2.png';
import BREATH_TIMES from './assets/images/basic/breath-times.png';
import SLEEP_QUALITY from './assets/images/basic/sleep-quality.png';

import MOTECKICON_LEFT from './assets/images/MoteckIcon_Left.png';
import MOTECKICON_RIGHT from './assets/images/MoteckIcon_Right.png';

import DIAPER_THROUGHT from './assets/images/basic/diaper-throught.png';
import DIAPER_WEIGHT from './assets/images/basic/diaper-weight.png';

import NORISE_0 from './assets/images/basic/norise-0.png';
import BACKRISE_15 from './assets/images/basic/backrise-15.png';
import BACKRISE_30 from './assets/images/basic/backrise-30.png';
import BACKRISE_45 from './assets/images/basic/backrise-45.png';
import BACKRISE_60 from './assets/images/basic/backrise-60.png';
import BACKRISE_75 from './assets/images/basic/backrise-75.png';
import BFRISE from './assets/images/basic/bfrise.png';
import FOOTRISE_15 from './assets/images/basic/footrise-15.png';
import FOOTRISE_30 from './assets/images/basic/footrise-30.png';
import FOOTRISE_45 from './assets/images/basic/footrise-45.png';
import FOOTRISE_60 from './assets/images/basic/footrise-60.png';
import FOOTRISE_75 from './assets/images/basic/footrise-75.png';
import TURNOVER_TIMES from './assets/images/basic/turnover-times.png';
import TURNOVER_LEFT from './assets/images/basic/turnover-left.png';
import TURNOVER_LEFTV2 from './assets/images/basic/turnover-leftv2.png';
import TURNOVER_RIGHT from './assets/images/basic/turnover-right.png';
import TURNOVER_RIGHTV2 from './assets/images/basic/turnover-rightv2.png';

import ICON_INFO_EMERGENCY_1 from './assets/images/icon_info_emergency_1.png';
import ICON_INFO_EMERGENCY_2 from './assets/images/icon_info_emergency_2.png';
import ICON_INFO_HISTORY_1 from './assets/images/icon_info_history_1.png';
import ICON_INFO_HISTORY_2 from './assets/images/icon_info_history_2.png';
import ICON_INFO_BASIC_1 from './assets/images/icon_info_basic_1.png';
import ICON_INFO_BASIC_2 from './assets/images/icon_info_basic_2.png';
import ICON_INFO_SETTINGS_1 from './assets/images/icon_info_settings_1.png';
import ICON_INFO_SETTINGS_2 from './assets/images/icon_info_settings_2.png';
import ICON_SE_INBED from './assets/images/sleep-inbed.png';
import ICON_SE_WAKEUP from './assets/images/sleep-wakeup.png';

import LONG_STAY from './assets/images/basic/long-stay.png';
import DB_INFO from './assets/images/basic/Dashboard_info.png';

import LOGO_COMPANY_LOGIN from './assets/images/logo_company_login.png';
import LOGO_COMPANY_NAV_1 from './assets/images/logo_company_nav_1.png';
import LOGO_COMPANY_NAV_2 from './assets/images/logo_company_nav_1.png';
import LOGO_COMPANY_NAV_3 from './assets/images/logo_company_nav_1.png';
import LOGO_ECG_ATTR from './assets/images/logo_ecg_attr.svg';
import LOGO_ECG_CSS from './assets/images/logo_ecg_css.svg';

import IN_BED from './assets/images/in_bed.png';
import NOT_IN_BED_RED from './assets/images/not_in_bed_red.png';
import IN_BED_ORANGE from './assets/images/in_bed_orange.png';
import TEST_IMG from './assets/images/in_bed.png';
import TEST_IMG1 from './assets/images/breath_low.png';

import LEVEL_0_1_NO_IN_BED from './assets/images/basic/icon1-1.png';
import LEVEL_0_4_IN_BED from './assets/images/basic/icon2-1.png';
import LEVEL_0_7_left_lying from './assets/images/basic/left_lying.png';
import LEVEL_0_8_right_lying from './assets/images/basic/right_lying.png';
import LEVEL_0_12_SIT_UP from './assets/images/basic/icon3-1.png';
import LEVEL_0_13_ENTER from './assets/images/basic/icon10-1.png';
import LEVEL_0_14_EXIT from './assets/images/basic/icon4-1.png';
import LEVEL_0_15_SIDE_LYING from './assets/images/basic/icon5-1.png';
import LEVEL_0_103_RESPIRATORY from './assets/images/basic/lung-1.png';
import LEVEL_0_203_HARNESSBREAK from './assets/images/basic/bed_203.png';
import LEVEL_0_206_TRANSCEIVER_OFFLINE from './assets/images/basic/icon8-2.png';
import LEVEL_0_208_TRANSCEIVER_ONLINE from './assets/images/basic/icon8-1.png';
import LEVEL_0_501_AWAKE_DETECTED from './assets/images/awake/awake_detected.png';
import LEVEL_0_505_RESTLESS_CHECK from './assets/images/awake/restless_check.png';
import LEVEL_0_511_MOBILITY_TOO_HIGH from './assets/images/awake/mobility_too_hig_black.png';
import LEVEL_0_512_MOBILITY_TOO_LOW from './assets/images/awake/mobility_too_low_black.png';

import LEVEL_1_1_NO_IN_BED from './assets/images/basic/icon1-2.png';
import LEVEL_1_4_IN_BED from './assets/images/basic/icon2-1.png';
import LEVEL_1_7_left_lying from './assets/images/basic/left_lying.png';
import LEVEL_1_8_right_lying from './assets/images/basic/right_lying.png';
import LEVEL_1_203_HARNESSBREAK from './assets/images/basic/bed_203.png';
import LEVEL_1_206_TRANSCEIVER_OFFLINE from './assets/images/basic/icon8-2.png';
import LEVEL_1_208_TRANSCEIVER_ONLINE from './assets/images/basic/icon8-1.png';
import LEVEL_1_211_RESOLVE_ALERT_BY_BED from './assets/images/basic/resolve-alert-by-bed.png';
import LEVEL_1_212_RESOLVE_ALERT_BY_STATION from './assets/images/basic/resolve-alert-by-station.png';
import LEVEL_1_501_AWAKE_DETECTED from './assets/images/awake/awake_detected.png';
import LEVEL_1_503_AWAKE_EMERGE from './assets/images/awake/awake_emerge.png';
import LEVEL_1_511_MOBILITY_TOO_HIGH from './assets/images/awake/mobility_too_hig_yellow.png';
import LEVEL_1_512_MOBILITY_TOO_LOW from './assets/images/awake/mobility_too_low_yellow.png';

import LEVEL_2_1_NO_IN_BED from './assets/images/basic/icon1-3.png';
import LEVEL_2_4_IN_BED from './assets/images/basic/icon2-1.png';
import LEVEL_2_7_left_lying from './assets/images/basic/left_lying.png';
import LEVEL_2_8_right_lying from './assets/images/basic/right_lying.png';
import LEVEL_2_12_SIT_UP from './assets/images/basic/icon3-3.png';
import LEVEL_2_14_EXIT from './assets/images/basic/icon4-3.png';
import LEVEL_2_203_HARNESSBREAK from './assets/images/basic/bed_203.png';
import LEVEL_2_206_TRANSCEIVER_OFFLINE from './assets/images/basic/icon8-2.png';
import LEVEL_2_208_TRANSCEIVER_ONLINE from './assets/images/basic/icon8-1.png';
import LEVEL_2_217_LONG_STAY from './assets/images/basic/icon7-3.png';
import LEVEL_2_218_LEAVING_OVERTIME from './assets/images/basic/icon6-3.png';
import LEVEL_2_502_AWAKE_RESTLESS from './assets/images/awake/awake_restless.png';
import LEVEL_2_503_AWAKE_EMERGE from './assets/images/awake/awake_emerge.png';
import LEVEL_2_504_AWAKE_ALREADY from './assets/images/awake/awake_already.png';
import LEVEL_2_511_MOBILITY_TOO_HIGH from './assets/images/awake/mobility_too_high.png';
import LEVEL_2_512_MOBILITY_TOO_LOW from './assets/images/awake/mobility_too_low.png';

import DIAPER_ANGLE_80 from './assets/images/diaper/diaper80-100.png';
import DIAPER_ANGLE_350 from './assets/images/diaper/diaper10-350.png';
import DIAPER_ANGLE_101 from './assets/images/diaper/diaper101-150.png';
import DIAPER_ANGLE_11 from './assets/images/diaper/diaper11-29.png';
import DIAPER_ANGLE_151 from './assets/images/diaper/diaper151-169.png';
import DIAPER_ANGLE_170 from './assets/images/diaper/diaper170-190.png';
import DIAPER_ANGLE_191 from './assets/images/diaper/diaper191-259.png';
import DIAPER_ANGLE_260 from './assets/images/diaper/diaper260-280.png';
import DIAPER_ANGLE_281 from './assets/images/diaper/diaper281-349.png';
import DIAPER_ANGLE_30 from './assets/images/diaper/diaper30-79.png';

import LOGIN_IMG from './assets/images/Login_Img.png';

import FRONTPAGE from './assets/images/navbar/Icon_FrontPage.png';
import RESIDENTS from './assets/images/navbar/Icon_Residents.png';
import PAD from './assets/images/navbar/Icon_Pad.png';
import NURSE from './assets/images/navbar/Icon_Nurse.png';
import LANG from './assets/images/navbar/Icon_Lang.png';
import USER from './assets/images/navbar/Icon_User.png';
import AB from './assets/images/navbar/Icon_AB.png';
import DEVICE from './assets/images/navbar/Icon_Device.png';

import AUTO_HISTORY from './assets/images/tabs/Icon_AutoHistory.png';
import AUTO_PARAMS from './assets/images/tabs/Icon_AutoParams.png';
import AUTO_PARAMS_SETTING from './assets/images/tabs/Icon_AutoParamsSetting.png';
import BED_STATE from './assets/images/tabs/Icon_BedState.png';
import INFO from './assets/images/tabs/Icon_Info.png';
import SE from './assets/images/tabs/Icon_SE.png';
import SENSOR_SETTING from './assets/images/tabs/Icon_SensorSetting.png';
import VITAL from './assets/images/tabs/Icon_Vital.png';
import DAIPER from './assets/images/tabs/Diaperhis.svg';
import EPMED_DC from './assets/images/tabs/Icon_DC.png';

import NODE_PADS from './assets/images/admin/pads@2x.png';
import NETWORK from './assets/images/admin/network@2x.png';
import ADMIN_USERS from './assets/images/admin/users@2x.png';
import SERVER from './assets/images/admin/server@2x.png';
import OTHER from './assets/images/admin/other@2x.png';
import INSTITUTION from './assets/images/admin/institution.svg';
import WIFI_LOCK from './assets/images/admin/wifi_lock.svg';

import WIFI_FULL from './assets/images/wifi-icon/wifi-full.png';
import WIFI_1 from './assets/images/wifi-icon/wifi-1.png';
import WIFI_2 from './assets/images/wifi-icon/wifi-2.png';
import WIFI_3 from './assets/images/wifi-icon/wifi-3.png';
import WIFI_OFF from './assets/images/wifi-icon/wifi-off.png';

const comm_imgs = Object.freeze({
  // 宣告 common_images 一切為唯讀性質

  // ✎NOTE: Card Icon - Scientech(宣佑)
  AUTHORITY_MGMT_ICON,
  BODY_TEMP_ICON,
  BREATH_ICON,
  WEIGHT_SCALE,
  DOOR_CLOSE,
  DOOR_OPEN,
  GLUCOSEMETER_ICON,
  HISTORY_ACTIVITY_ICON,
  HISTORY_SLEEP_ICON,
  HUMID_ICON,
  OXIMETER_ICON,
  PERSONAL_SETTINGS_ICON,
  SETTING_RESPO_GROUP_ICON,
  SLEEP_EFFICIENCY_ICON,
  SPHYGMOMANOMETER_ICON,
  TEMP_ICON,
  TEMP_ICON_1,
  TOILET_CLOSE_ICON,
  TOILET_OPEN_ICONA,
  TOILET_OPEN_ICONB,
  TRANSCEIVER_INFO_ICON,
  WEIGHT_ICON,
  VIBRATION_ICON,

  // ✎NOTE: Basic
  HEARTBEAT,
  HEARTBEAT_SVG,
  HEARTBEAT_1,
  HEARTBEAT_2,
  HEARTBEAT_3,
  BREATH_TIMES_1,
  BREATH_TIMES_SVG,

  // ✎NOTE: Dashboard Icon
  ICONA_1,
  ICONA_2,
  ICONA_3,
  ICONB_1,
  ICONB_2,
  ICONC_1,
  ICONC_2,
  BREATH_TIMES,
  SLEEP_QUALITY,
  MOTECKICON_LEFT,
  MOTECKICON_RIGHT,
  DIAPER_THROUGHT,
  DIAPER_WEIGHT,

  // ✎NOTE: 床的狀態
  NORISE_0,
  BACKRISE_15,
  BACKRISE_30,
  BACKRISE_45,
  BACKRISE_60,
  BACKRISE_75,
  BFRISE,
  FOOTRISE_15,
  FOOTRISE_30,
  FOOTRISE_45,
  FOOTRISE_60,
  FOOTRISE_75,
  TURNOVER_TIMES,
  TURNOVER_LEFT,
  TURNOVER_LEFTV2,
  TURNOVER_RIGHT,
  TURNOVER_RIGHTV2,

  // ✎NOTE: Panel Icon
  ICON_INFO_EMERGENCY_1,
  ICON_INFO_EMERGENCY_2,
  ICON_INFO_HISTORY_1,
  ICON_INFO_HISTORY_2,
  ICON_INFO_BASIC_1,
  ICON_INFO_BASIC_2,
  ICON_INFO_SETTINGS_1,
  ICON_INFO_SETTINGS_2,
  ICON_SE_INBED,
  ICON_SE_WAKEUP,

  // ✎NOTE: AB床用icon
  LONG_STAY,
  DB_INFO,

  // ✎NOTE: 公司 Logo
  LOGO_COMPANY_LOGIN,
  LOGO_COMPANY_NAV_1,
  LOGO_COMPANY_NAV_2,
  LOGO_COMPANY_NAV_3,
  LOGO_ECG_ATTR,
  LOGO_ECG_CSS,

  // ✎NOTE: 測用的圖片
  IN_BED,
  NOT_IN_BED_RED,
  IN_BED_ORANGE,
  TEST_IMG,
  TEST_IMG1,
  BREATH_LOW,

  // ✎NOTE: 更新!!!!!! Alert 等級分級示意圖
  LEVEL_0: {
    '1_NO_IN_BED': LEVEL_0_1_NO_IN_BED,
    '4_IN_BED': LEVEL_0_4_IN_BED,
    '7_left_lying': LEVEL_0_7_left_lying,
    '8_right_lying': LEVEL_0_8_right_lying,
    '12_SIT_UP': LEVEL_0_12_SIT_UP,
    '13_ENTER': LEVEL_0_13_ENTER,
    '14_EXIT': LEVEL_0_14_EXIT,
    '15_SIDE_LYING': LEVEL_0_15_SIDE_LYING,
    '103_RESPIRATORY': LEVEL_0_103_RESPIRATORY,
    '203_HARNESSBREAK': LEVEL_0_203_HARNESSBREAK,
    '206_TRANSCEIVER_OFFLINE': LEVEL_0_206_TRANSCEIVER_OFFLINE,
    '208_TRANSCEIVER_ONLINE': LEVEL_0_208_TRANSCEIVER_ONLINE,
    "501_AWAKE_DETECTED": LEVEL_0_501_AWAKE_DETECTED,
    "505_RESTLESS_CHECK": LEVEL_0_505_RESTLESS_CHECK,
    "511_MOBILITY_TOO_HIGH": LEVEL_0_511_MOBILITY_TOO_HIGH,
    "512_MOBILITY_TOO_LOW": LEVEL_0_512_MOBILITY_TOO_LOW,
  },
  LEVEL_1: {
    '1_NO_IN_BED': LEVEL_1_1_NO_IN_BED,
    '4_IN_BED': LEVEL_1_4_IN_BED,
    '7_left_lying': LEVEL_1_7_left_lying,
    '8_right_lying': LEVEL_1_8_right_lying,
    '203_HARNESSBREAK': LEVEL_1_203_HARNESSBREAK,
    '206_TRANSCEIVER_OFFLINE': LEVEL_1_206_TRANSCEIVER_OFFLINE,
    '208_TRANSCEIVER_ONLINE': LEVEL_1_208_TRANSCEIVER_ONLINE,
    "211_RESOLVE_ALERT_BY_BED": LEVEL_1_211_RESOLVE_ALERT_BY_BED,
    "212_RESOLVE_ALERT_BY_STATION": LEVEL_1_212_RESOLVE_ALERT_BY_STATION,
    "501_AWAKE_DETECTED": LEVEL_1_501_AWAKE_DETECTED,
    "503_AWAKE_EMERGE": LEVEL_1_503_AWAKE_EMERGE,
    "511_MOBILITY_TOO_HIGH": LEVEL_1_511_MOBILITY_TOO_HIGH,
    "512_MOBILITY_TOO_LOW": LEVEL_1_512_MOBILITY_TOO_LOW,
  },
  LEVEL_2: {
    '1_NO_IN_BED': LEVEL_2_1_NO_IN_BED,
    '4_IN_BED': LEVEL_2_4_IN_BED,
    '7_left_lying': LEVEL_2_7_left_lying,
    '8_right_lying': LEVEL_2_8_right_lying,
    '12_SIT_UP': LEVEL_2_12_SIT_UP,
    '14_EXIT': LEVEL_2_14_EXIT,
    '203_HARNESSBREAK': LEVEL_2_203_HARNESSBREAK,
    '206_TRANSCEIVER_OFFLINE': LEVEL_2_206_TRANSCEIVER_OFFLINE,
    '208_TRANSCEIVER_ONLINE': LEVEL_2_208_TRANSCEIVER_ONLINE,
    '217_LONG_STAY': LEVEL_2_217_LONG_STAY,
    '218_LEAVING_OVERTIME': LEVEL_2_218_LEAVING_OVERTIME,
    "502_AWAKE_RESTLESS": LEVEL_2_502_AWAKE_RESTLESS,
    "503_AWAKE_EMERGE": LEVEL_2_503_AWAKE_EMERGE,
    "504_AWAKE_ALREADY": LEVEL_2_504_AWAKE_ALREADY,
    "511_MOBILITY_TOO_HIGH": LEVEL_2_511_MOBILITY_TOO_HIGH,
    "512_MOBILITY_TOO_LOW": LEVEL_2_512_MOBILITY_TOO_LOW,
  },
  DIAPER_ANGLE: {
    11: DIAPER_ANGLE_11,
    30: DIAPER_ANGLE_30,
    80: DIAPER_ANGLE_80,
    101: DIAPER_ANGLE_101,
    151: DIAPER_ANGLE_151,
    170: DIAPER_ANGLE_170,
    191: DIAPER_ANGLE_191,
    260: DIAPER_ANGLE_260,
    281: DIAPER_ANGLE_281,
    350: DIAPER_ANGLE_350,
  },

  // ✎NOTE: login page用img
  LOGIN_IMG,

  // ✎NOTE: navbar用icon
  FRONTPAGE,
  RESIDENTS,
  PAD,
  NURSE,
  LANG,
  USER,
  AB,
  DEVICE,

  // ✎NOTE: 彈出視窗分頁用icon
  AUTO_HISTORY,
  AUTO_PARAMS,
  AUTO_PARAMS_SETTING,
  BED_STATE,
  INFO,
  SE,
  SENSOR_SETTING,
  VITAL,
  DAIPER,
  EPMED_DC,

  // admin
  NODE_PADS,
  NETWORK,
  ADMIN_USERS,
  SERVER,
  OTHER,
  INSTITUTION,
  WIFI_LOCK,


  // wifi icons
  WIFI_FULL,
  WIFI_1,
  WIFI_2,
  WIFI_3,
  WIFI_OFF,
});

export default comm_imgs;
